<template>
    <ModalComponent
        name="modal-region-sin-numerar"
        :title="$t('partido.elige_entradas')"
        :subtitle="$t('partido.varias_entradas')"
        @close="$emit('close')"
    >
        <div class="px-0 px-lg-3">
            <p class="m-0 h3 text-uppercase">{{regionSeleccionada.nombre}}</p>
            <hr>

            <ul class="list-group list-group-flush">
                <li 
                    v-for="(precio, index) in preciosSelected" :key="index"
                    class="list-group-item d-flex justify-content-between align-items-center"
                >
                    <div class="text-bold h4 d-flex flex-column">
                        <span class="h4">{{ precio.descripcion }} <small>({{ precio.precio }}€)</small></span>
                        <small class="text-muted">{{ precio.informacion }}</small>
                    </div>
                    <div class="d-flex align-items-center">
                        <button
                            class="button panzoom-button"
                            :disabled="precio.n_entradas === 0"
                            @click="precio.n_entradas--"
                        >
                            -
                        </button>
                        <p class="text-bold mx-2">{{ precio.n_entradas }}</p>
                        <button
                            class="button panzoom-button"
                            :disabled="totalEntradas === 10 || totalEntradas === regionSeleccionada.libres"
                            @click="precio.n_entradas++"
                        >
                            +
                        </button>
                    </div>
                </li>
            </ul>
            <button
                class="button effect-button float-right mt-4"
                :disabled="totalEntradas === 0"
                @click="continuarCompra"
            >
                <span>Continuar</span>
            </button>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from '../../../../backend/components/ModalComponent.vue';

export default {
    props: {
        n_max_entradas: {
            type: Number,
            required: false,
            default: 10
        },
        precios: {
            type: Array,
            required: true,
        },
        regionSeleccionada: {
            type: Object,
            required: true
        }
    },
    emits: ['close', 'setAsientos'],
    created() {
        if (this.precios) {
            this.preciosSelected = JSON.parse(JSON.stringify(this.precios));
            this.preciosSelected.forEach((precio, index) => {
                this.$set(this.preciosSelected, index, {
                    ...precio,
                    n_entradas: 0
                });
            });
        }
    },
    data() {
        return {
            preciosSelected: null,
        }
    },
    computed: {
        totalEntradas() {
            return this.preciosSelected.reduce((sum, precio) => sum + precio.n_entradas, 0);
        }
    },
    methods: {
        continuarCompra() {
            const datos = [];
            const preciosFiltered = this.preciosSelected.filter(precio => precio.n_entradas > 0);

            preciosFiltered.forEach(precio => {
                for (let i = 0; i < precio.n_entradas; i++) {
                    datos.push({
                        'apellidos': '',
                        'asiento': {
                            'zona_id': this.regionSeleccionada.id,
                            'asiento': 0,
                            'fila': 0,
                            'zona_nombre': this.regionSeleccionada.nombre
                        },
                        'dni': '',
                        'es_nuevo': true,
                        'nombre': '',
                        'precio': precio,
                        'precios': this.regionSeleccionada.precios,
                        'telefono': '',
                        'url_imprimir': '',
                        'zonaSeleccionada': this.regionSeleccionada,
                        'precioSeleccionado': precio,
                        'fila': 0,
                        'butaca': 0
                    });                    
                }
            })
            this.$emit('setAsientos', datos);
            this.$nextTick(() => {
                this.$emit('close');
            });
        }
    },
    components: { ModalComponent }
}
</script>